import React, { useEffect, useState } from 'react';
import { Table } from 'antd';

import { receptionsService } from '../../services/ReceptionsService';
import { useNavigate, useParams } from 'react-router-dom';
import './ReceptionDetails.scss';
import Menu from '../../components/Menu/Menu';
import MobileBottomMenu from '../../components/MobileBottomMenu/MobileBottomMenu';
import MobileMenu from "../../components/Menu/MobileMenu";
import ReactPaginate from 'react-paginate';

const ReceptionDetails = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [receptions, setReceptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [pagination, setPagination] = useState({});

    useEffect(() => {
        receptionsService.getReception(id)
            .then(response => {
                setReceptions(response.data.receipt_items);
                setPagination(response.data.pagination);
            })
            .catch(error => {
                setError('Failed to fetch receptions.');
                console.error('Error fetching receptions:', error);
            })
            .finally(() => setLoading(false));
    }, []);

    const handlePageClick = (data) => {
        receptionsService.getReception(id, data.selected + 1)
            .then(response => {
                if (response.status === 401) {
                    navigate("/login");
                } else {
                    setReceptions(response.data.receipt_items);
                    setPagination(response.data.pagination);
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    navigate("/login");
                } else {
                    console.error('Error fetching data:', error);
                }
            });
    };

    const columns = [
        {
            title: 'Denumirea bunurilor receptionate',
            dataIndex: 'product_name',
            key: 'product_name',
        },
        {
            title: 'Denumire produs intern',
            key: 'product_name_internal',
            render: (text, record) => record.product?.name || '-'
        },
        {
            title: 'TVA',
            dataIndex: 'vat_percent',
            key: 'vat_percent',
        },
        {
            title: 'UM',
            key: 'measurement_unit',
            dataIndex:'measurement_unit'
        },
        {
            title: 'Cantitate',
            dataIndex: 'quantity',
            key: 'quantity',
        },
        {
            title: 'Furnizor',
            children: [
                {
                    title: 'Cantitate conform doc',
                    dataIndex: 'received_quantity',
                    key: 'received_quantity',
                },
                {
                    title: 'Pret unitar',
                    dataIndex: 'unit_price_without_vat',
                    key: 'unit_price_without_vat',
                },
                {
                    title: 'PA-TVA',
                    dataIndex: 'total_value_without_vat',
                    key: 'total_value_without_vat',
                },
                {
                    title: 'Total TVA',
                    dataIndex: 'vat_value',
                    key: 'vat_value',
                },
                {
                    title: 'Total Fact',
                    dataIndex: 'total_value_with_vat',
                    key: 'total_value_with_vat',
                }
            ],
        },
        {
            title: 'Adaos comercial',
            children: [
                {
                    title: ' %',
                    dataIndex: 'commercial_margin_percent',
                    key: 'commercial_margin_percent',
                },
                {
                    title: 'Unitar',
                    dataIndex: 'commercial_margin_value_per_unit',
                    key: 'commercial_margin_value_per_unit',
                },
                {
                    title: 'Total',
                    dataIndex: 'commercial_margin_value',
                    key: 'commercial_margin_value',
                }
            ],
        },

        {
            title: 'PV-TVA',
            dataIndex: 'selling_price_without_vat_per_unit',
            key: 'selling_price_without_vat_per_unit',
        },
        {
            title: 'TVA Vanzare',
            children: [
                {
                    title: 'Aferent adaos',
                    dataIndex: 'selling_vat_commercial_margin',
                    key: 'selling_vat_commercial_margin',
                },
                {
                    title: 'Unitar',
                    dataIndex: 'selling_vat_price_unit',
                    key: 'selling_vat_price_unit',
                },
                {
                    title: 'Total',
                    dataIndex: 'selling_vat_total',
                    key: 'selling_vat_total',
                }
            ],
        },
        {
            title: 'PV',
            children: [
                {
                    title: 'Unitar',
                    dataIndex: 'selling_price',
                    key: 'selling_price',
                },
                {
                    title: 'Total',
                    dataIndex: 'total_sale_value',
                    key: 'total_sale_value',
                }
            ]
        }
    ];

    if (loading) return <div className="loading">Loading...</div>;
    if (error) return <div className="error">{error}</div>;

    return (
        <div className='standard receptions'>
        <div className='standard__container'>
            <div className='standard__mobile-header'>
                <img src='/images/logo.png' alt='logo' className='standard__only-mobile standard__mobile-logo' />
                <MobileMenu />

            </div>
            <Menu />
            <div className='standard__wrapper receptions__wrapper'>

                <h2 className='receptions__title'>Nota de recepție</h2>
                <div className="table-container">
                    <Table columns={columns} dataSource={receptions} rowKey="id" pagination={false} scroll={{ x: true }} scroll={{ x: 'max-content' }} />
                </div>
                {pagination && pagination.total_pages && (
                    <ReactPaginate
                        previousLabel={'<'}
                        nextLabel={'>'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={pagination.total_pages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={1}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                    />
                )}
            </div>
            </div>
            {pagination && pagination.last_page && (
                <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={4}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={1}
                    onPageChange={handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                />
            )}
            <MobileBottomMenu />

        </div>
    );
};

export default ReceptionDetails;
